import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig';
import AxiosPostProcessor from './AxiosPostProcessor';
import Axios, { AxiosResponse } from 'axios';
import QueryStringUtility from './QueryStringUtility';
import GpxGeoJson from '@/GpxGeoJson';

export class GpxDownloadServiceStatic {
    downloadGpxFormUrl() { return `${process.env.VUE_APP_BASE_URL_API}/api/downloadgpx`; }

    downloadGpxFormRepeatGet(): Promise<AxiosResponse<ArrayBuffer>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/downloadgpx`
        return AxiosPostProcessor.postProcess(Axios.get<ArrayBuffer>(url, AxiosDefaultRequestConfig.merge({
          "responseType" : "blob"
        })));
    }

    downloadGpxFormRepeatPostNoContentType(): Promise<AxiosResponse<ArrayBuffer>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/downloadgpx`
        return AxiosPostProcessor.postProcess(Axios.post<ArrayBuffer>(url, AxiosDefaultRequestConfig.merge({
          "responseType" : "blob"
        })));
    }

    downloadGpxPublicUrl(gpxUrl: string, pointLimit: number|undefined, mergeSegmentsOnDownload: boolean) { return `${process.env.VUE_APP_BASE_URL_API}/api/download/${gpxUrl}${QueryStringUtility.getQueryString({pointLimit,mergeSegmentsOnDownload})}`; }

    downloadGpxPublicFormUrl() { return `${process.env.VUE_APP_BASE_URL_API}/api/download`; }

    uploadGpx(gpxBytes: ArrayBuffer, fileName: string): Promise<AxiosResponse<GpxGeoJson>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/uploadgpx`
        return AxiosPostProcessor.postProcess(Axios.post<GpxGeoJson>(url, gpxBytes, AxiosDefaultRequestConfig.merge({
          "headers" : {
            "UploadedGpxFileName" : fileName,
            "Content-Type" : "application/gpx+xml"
          }
        })));
    }
}
const GpxDownloadService = new GpxDownloadServiceStatic();
export default GpxDownloadService;
